import styled from 'styled-components';
import { sizes } from '../../../../themes/sizes';

export const QSContainer = styled.section`
  display: grid;
  grid-template-columns: 290px 1fr 50px;
  align-items: center;
  gap: ${sizes.margins.large};
  margin-bottom: ${sizes.margins.normal};
`;
export const QSPanelPrimary = styled.section``;
export const QSPanelSecondary = styled.section`
  display: grid;
  grid-template-columns: 75px 75px;
  align-items: center;
  justify-content: end;
  gap: 20px;
`;
export const QSPanelAction = styled.section`
  justify-self: end;
`;

export const QSPanelCalExceptions = styled.section`
  display: grid;
  align-items: center;
  justify-items: start;
`;
